var render = function render(){
  var _vm$me, _vm$me$point, _vm$me$point$format;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('h4', [_c('span', [_vm._v("상태: ")]), _vm.logOn ? _c('span', [_vm._v("로그인 상태입니다")]) : _vm._e(), _vm.logOff ? _c('span', [_vm._v("로그아웃 상태입니다")]) : _vm._e()])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('span', [_vm._v("보유포인트: " + _vm._s(((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : (_vm$me$point = _vm$me.point) === null || _vm$me$point === void 0 ? void 0 : (_vm$me$point$format = _vm$me$point.format) === null || _vm$me$point$format === void 0 ? void 0 : _vm$me$point$format.call(_vm$me$point)) || 0) + "원")])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.init();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "20"
    }
  }, [_vm._v("mdi-refresh")]), _vm._v(" 새로고침 ")], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }